/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
// 选择放款机构
import {
  Component,
  Watch,
  Mixins,
  Prop,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { confirmDialog } from '@/components/dialog';
import {
  ChannelAvailableEnum,
  ChannelDisableEnum,
} from '@/api/apply-product/types';

import type {
  ApplyChannelData,
  ApplyProductData,
  ProductCapitalItem,
} from '@/api/apply-product/types';

import { Dialog } from '@hb/coffee';
import { RouterV2Enum } from '@/router/router-names';
import FinanceBusiness from '@/mixins/finance-business';
import type { CouponRolePo } from '@/api/coupon/types';
import platform from '@/shared/utils/platform';
import { DialogTextEnum } from '@/views_v2/apply-product/types';
import '@/views_v2/home/store';
import RouterHelper from '@/shared/utils/routerHelper';
import { IS_PRERENDERING } from '@hb/coffee-prerender';
import { popPageManager } from '@/shared/tools/popPageManager';
import { PopPage } from '@/shared/tools/popPageManager/types';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import router from '@/router';
import NewSelectChannel from '../new-select-channel/index';
import SelectChannelFormField from '../select-channel-form-field/index.vue';
import { getDoubleModeCommonUbtParams } from '../../product';

const style = require('./index.module.scss') as Dictionary;

const ApplyProductStore = namespace('applyProduct');
const LoanRightStore = namespace('loanRight');
const HomeStore = namespace('home');

/** 推荐渠道被切换挽留弹窗 */
const SwitchChannelRemindPopup = () => import(
  /* webpackChunkName: "switch-channel-remind-popup" */'../switch-channel-remind-popup/index.vue'
) as any;

/** 弹窗每次打开组件1次控制状态 */
enum PopupOnceControlStatus {
  /** 初始状态，未打开过弹窗 */
  INITIAL = 0,
  /** 处理中，正在打开弹窗 */
  PROCESSING = 1,
  /** 已结果，不再弹窗 */
  FINISHED = 2,
}
/** 推荐渠道被切换挽留弹窗控制状态-缓存 */
let scRemindPopupControlStatusCache: PopupOnceControlStatus = PopupOnceControlStatus.INITIAL;
/** 当用户退出提现页时，重置挽留弹窗控制状态（非回退场景） */
export const resetSelectChannelRemindPopupControl = (): void => {
  scRemindPopupControlStatusCache = PopupOnceControlStatus.INITIAL;
};

@Component
export default class SelectChannel extends Mixins(FinanceBusiness) {
  @ApplyProductStore.State amount!: string;

  @ApplyProductStore.State channel!: ApplyChannelData;

  @ApplyProductStore.State channelList!: ApplyChannelData[];

  @ApplyProductStore.State optimizationNoAvailableProduct!: boolean;

  @ApplyProductStore.State channelGrayTest!: number;

  @ApplyProductStore.State coupon!: CouponRolePo;

  @ApplyProductStore.State product!: ApplyProductData;

  @ApplyProductStore.State replanResultErrMsg!: boolean;

  @ApplyProductStore.State selectRightInCapital!: ProductCapitalItem | null;

  @ApplyProductStore.Getter isPopupSwitchChannel!: boolean;

  @ApplyProductStore.Action changeSelectCapitalForRight!: (payload: {
    productCapitalItem: ProductCapitalItem,
  }) => Promise<void>;

  @ApplyProductStore.Action $updateState!: (data: Dictionary) => void;

  @ApplyProductStore.Action selectApplyChannel!: (payload: {
    channel: ApplyChannelData;
  }) => Promise<void>;

  // 查询签约状态
  @ApplyProductStore.Action checkAlipayStatus!: () => Promise<void>;

  // 期数
  @ApplyProductStore.Action getPeriodData!: (currentAmount: string) => Promise<void>;

  @LoanRightStore.Action initSuperMemberCardState!: () => void;

  @HomeStore.Action getUserAutarkyState!: () => Promise<boolean>;

  @Prop() private position!: 'top' | 'form';

  /** 模块曝光次数限制 */
  private moduleExposeOnce = false;

  // 拦截状态
  private get isGlobalLocalStatus() {
    return [
      ChannelAvailableEnum.GLOBALLOCALINTERCEPTION,
    ].indexOf(Number(this.channel && this.channel.disabledStatus)) >= 0;
  }

  @Watch('replanResultErrMsg')
  private onReplanResult(val: boolean) {
    if (val) {
      this.showCreditUnavailDialog(
        `经${this.channel.productName || ''}的风险评估，您的风险等级较高，额度暂时冻结，请更换渠道或重新授信。如有问题请联系${this.channel.productName}。`,
      );
    }
  }

  @Watch('channelGrayTest')
  private onChangeStatus(val: number) {
    if (val) {
      this.checkChannelStatus();
    }
  }

  @Watch('channelList', { immediate: true })
  private channelListChange(list: ApplyChannelData[] | undefined) {
    // TODO: 会曝光2次
    if (!this.moduleExposeOnce && list && list.length) {
      this.moduleExposeOnce = true;

      this.$ubtModuleExposeNew(
        'finance_FinanceLoanApply_lenders',
        getDoubleModeCommonUbtParams(list),
      );
    }
  }

  /** 监听双承接模式用户选择的资方变化，更新当前渠道 */
  @Watch('selectRightInCapital')
  private updateSelectChannel(newProduct: ProductCapitalItem, oldProduct: ProductCapitalItem) {
    /** 首次初始化时，非tab卡切换无需更新 */
    if (newProduct && oldProduct && newProduct.capitalCode !== oldProduct.capitalCode) {
      this.changeSelectCapitalForRight({
        productCapitalItem: newProduct,
      }).then(() => {
        this.getPeriodData(this.amount);
      });
    }
  }

  private scRemindPopupControlStatus = scRemindPopupControlStatusCache;

  private scRemindPopupControlResolve: ((value: boolean) => void) | null = null;

  /**
   * 渠道可用检查，若无可用渠道则弹窗提示
   * 普通客群，导向授信申请页面
   * 老客客群，导向首页
   * 进入实验1且处于额度隔离，释放额度刷新页面
   * */
  private checkChannelStatus() {
    /** 所有渠道是否不可用 */
    const isChannelNotAvailable = this.channelList.every(
      (channel) => channel.disabled === ChannelDisableEnum.NOT_AVAILABLE,
    );

    /** 是否已授信，用户判断普通客群与老客客群 */
    const isAutarkySucceed = this.isAutarkySucceed();

    let DIALOG_TITLE = '无法提现提醒';
    let DIALOG_CONTENT = '抱歉，由于资质审核失败，您已有的所有额度已失效，推荐您重新申请新额度。';
    let DIALOG_BTN_TEXT = '申请新额度';

    /** 进入实验1且处于额度隔离 */
    if (this.optimizationNoAvailableProduct) {
      DIALOG_TITLE = '额度刷新提醒';
      DIALOG_CONTENT = '当前机构额度暂不可用，已为您重新匹配额度，刷新后即可提现。';
      DIALOG_BTN_TEXT = '刷新额度';
    } else if (isAutarkySucceed) {
      DIALOG_CONTENT = '抱歉，由于资质审核失败，您已有的所有额度已失效。';
      DIALOG_BTN_TEXT = '确定';
    }

    /** 支付宝小程序场景，文案固定，引导用户去哈啰app提现 */
    if (platform.isAlipayMini) {
      DIALOG_TITLE = '温馨提示';
      DIALOG_CONTENT = '请前往"哈啰APP首页-借钱"进行提现';
      DIALOG_BTN_TEXT = '确定';
    }

    if (isChannelNotAvailable) {
      if (platform.isAlipayMini) {
        ubtSetupModuleExpose('finance_loan_apply_alipay36Guide', {
          scene: 'alimini_no_channel_available',
        });
      }
      confirmDialog.open({
        title: DIALOG_TITLE,
        content: DIALOG_CONTENT,
        confirmText: DIALOG_BTN_TEXT,
        showCloseIcon: false,
        ubtName: 'finance_loan_checkFailPopup',
        businessInfo: {
          buttonName: DIALOG_BTN_TEXT,
        },
      }).then(() => {
        /** 支付宝小程序场景，引导用户去哈啰app提现 */
        if (platform.isAlipayMini) {
          ubtSetupPageButton('finance_loan_apply_alipay36Guide_agree', {
            scene: 'alimini_no_channel_available',
          });
          router.replace({
            path: RouterV2Enum.alipayCreditGuide,
            query: {
              /** 取渠道的可用额度 */
              amount: this.channel.availableAmount || '0',
            },
          });
          return;
        }
        if (this.optimizationNoAvailableProduct) {
          window.location.reload();
        } else if (isAutarkySucceed) {
          this.goHome();
        } else {
          this.reApplyCredit();
        }
      });
    } else {
      confirmDialog.close();
    }
  }

  private switchToNormalChannel(rightLight36ProductId?: string) {
    // 只有传递了有效的productId才执行切换
    if (rightLight36ProductId) {
      const newChannel = this.channelList.find(
        (channel) => channel.productId === rightLight36ProductId,
      );
      if (newChannel && newChannel.productId !== this.channel.productId) {
        this.commonChangeChannel(newChannel, false);
      }
    }
  }

  private switchToSpeedChannel() {
    const newChannel = this.channelList.find((channel) => channel.productId === '8180');
    if (newChannel && newChannel.productId !== this.channel.productId) {
      this.onSelectChannel(newChannel, false);
    }
  }

  private async mounted() {
    if (!IS_PRERENDERING) {
      await this.getUserAutarkyState();
    }

    // 监听事件总线的切换通道事件
    this.$root.$on('switchToNormalChannel', this.switchToNormalChannel);
    this.$root.$on('switchToSpeedChannel', this.switchToSpeedChannel);
  }

  /** 销毁时异常弹窗，否则弹窗会带到其它页面上 */
  private beforeDestroy() {
    confirmDialog.close();
    Dialog.close();
    // 移除事件监听器
    this.$root.$off('switchToNormalChannel', this.switchToNormalChannel);
    this.$root.$off('switchToSpeedChannel', this.switchToSpeedChannel);
  }


  private render() {
    // 实验分流结果未确定时，不渲染模块
    if (this.isPopupSwitchChannel === null) {
      return null;
    }
    if (this.isPopupSwitchChannel) {
      // 提现页面优化实验选择渠道模块的位置与交互不同
      if (this.position === 'top') {
        return (
          <section class={style.selectChannel}></section>
        );
      }
      if (this.position === 'form') {
        return (
          <section>
            {/* 选择渠道表单项选择弹窗 */}
            <SelectChannelFormField
              channel={this.channel}
              product={this.product}
              channelList={this.channelList}
              switchChannelOpenRemindPopup={this.switchChannelOpenRemindPopup.bind(this)}
              onChange={this.onSelectChannel.bind(this)}
            />
            {// 挂载身份证清晰分不够弹窗 dom
              this.getUpdatedIdentityPhotoDialog()
            }
            <SwitchChannelRemindPopup
              ref="switchChannelRemindPopupRef"
              visible={this.scRemindPopupControlStatus === PopupOnceControlStatus.PROCESSING}
              onConfirm={() => this.scRemindPopupControlResolve?.(true)}
              onCancel={() => this.scRemindPopupControlResolve?.(false)}
            />
          </section>
        );
      }
    } else {
      if (this.position === 'top') {
        return (
          <section class={style.selectChannel}>
            {/* 多渠道露出新样式样式 */}
            <NewSelectChannel
              switchChannelOpenRemindPopup={this.switchChannelOpenRemindPopup.bind(this)}
              onChange={this.onSelectChannel.bind(this)}
            />
            {// 挂载身份证清晰分不够弹窗 dom
              this.getUpdatedIdentityPhotoDialog()
            }
            <SwitchChannelRemindPopup
              ref="switchChannelRemindPopupRef"
              visible={this.scRemindPopupControlStatus === PopupOnceControlStatus.PROCESSING}
              onConfirm={() => this.scRemindPopupControlResolve?.(true)}
              onCancel={() => this.scRemindPopupControlResolve?.(false)}
            />
          </section>
        );
      }
      if (this.position === 'form') {
        return null;
      }
    }
    return null;
  }

  /**
   * 用户切换渠道时，若挽留弹窗有展示次数，已选中的渠道属于推荐类型，而新选的渠道不是推荐类型，则进行挽留
   * 若用户选择同意，则本次渠道切换不生效
   * @param targetChannel 新选择的渠道
   * @returns 是否同意保留上次选择的渠道，true 表示同意，false 表示不同意
   */
  private switchChannelOpenRemindPopup(targetChannel: ApplyChannelData): Promise<boolean> {
    if (
      this.channel?.showPositivePopWindow === true
      && targetChannel?.showPositivePopWindow === false
      && this.scRemindPopupControlStatus === PopupOnceControlStatus.INITIAL
    ) {
      this.scRemindPopupControlStatus = PopupOnceControlStatus.PROCESSING;
      /** 注册至弹窗管理器，用户主动退出页面时，自动关闭弹窗 */
      popPageManager.addShowedPop(this.$refs.switchChannelRemindPopupRef as unknown as PopPage);

      this.$ubtModuleExposeNew(
        'finance_loan_apply_switchPopUp',
        {
          currentChannelId: this.channel?.productId,
          targetChannelId: targetChannel?.productId,
        },
      );

      const confirmTask = new Promise<boolean>((resolve) => {
        this.scRemindPopupControlResolve = resolve;
      });

      confirmTask.finally(() => {
        this.scRemindPopupControlResolve = null;
        this.scRemindPopupControlStatus = PopupOnceControlStatus.FINISHED;
        scRemindPopupControlStatusCache = PopupOnceControlStatus.FINISHED;
      });

      return confirmTask;
    }

    return Promise.resolve(false);
  }

  private commonChangeChannel(channel: ApplyChannelData, unAvailable: boolean) {
    if (this.coupon) {
      this.coupon.couponName = '';
    }
    this.selectApplyChannel({ channel }).then(() => {
      const oldQuery = this.$route.query;
      const { commodityId } = oldQuery || {};
      if (commodityId) {
      // 如果链接上有渠道 id，表示默认选中渠道，
      // 切换渠道的时候，url query 需刷新替换
      // 解决绑卡页面回退问题
        this.$router.replace({
          query: {
            commodityId: channel.productId,
          },
        });
      }
      this.getPeriodData(this.amount);
    });
  }

  private onSelectChannel(channel: ApplyChannelData, unAvailable: boolean) {
    // 重置24+单通道可换普通通道状态
    this.$updateState({
      is24NeedRightAndNormalIs36: false,
    });

    // 权益相关状态初始化
    this.initSuperMemberCardState();

    this.commonChangeChannel(channel, unAvailable);
  }

  // 重新授信
  private reApplyCredit() {
    this.isNeedEducation(
      'finance_reApplyCredit',
      ['产品', `${this.channel && this.channel.productId}`],
      true,
    );
  }

  private goHome() {
    if (platform.isSkApp) {
      RouterHelper.backHome();
    } else {
      this.$router.replace(RouterV2Enum.home);
    }
  }

  // 显示渠道 额度被冻结或者本次不可提现 弹窗
  private showCreditUnavailDialog(message: string) {
    const title = DialogTextEnum.TITLE;

    this.$ubtModuleExpose(
      'finance_FinanceLoanApply.Localinterception',
      'commodityId',
      this.channel && this.channel.productId,
      'status',
      (this.channel && `${this.channel.disabledStatus}`),
      'alertMsg',
      this.channel.alertMsg,
    );

    Dialog.alert({
      title,
      message,
      confirmButtonText: this.currentBtnText(),
      closeable: false,
    }).then(() => {
      // 重新授信
      this.$ubtPageButton('finance_FinanceLoanApply.Localinterception.Recredit',
        'commodityId',
        this.channel && this.channel.productId,
        'status',
        (this.channel && `${this.channel.disabledStatus}`));
      if (this.isGlobalLocalStatus) {
        this.goHome();
      } else {
        if (!this.isAutarkySucceed()) {
          this.reApplyCredit();
        } else {
          this.goHome();
        }
      }
    });
  }

  // 返回当前按钮文案
  private currentBtnText(): DialogTextEnum {
    if (this.isAutarkySucceed()) {
      return DialogTextEnum.SURE;
    }
    return this.isGlobalLocalStatus ? DialogTextEnum.WE_KNOW : DialogTextEnum.GET_QUOTA;
  }
}
